
<!-- <div class="seo-wrapper">
  <h1 class="main-heading">
    Medical Fundraising & Crowdfunding
  </h1>
  <p class="head">
    Online Medical crowdfunding is an alternative method for individuals and organisations to generate funds required for costly medical treatments like open-heart surgeries, NICU care, bone marrow transplant, cancer treatments and any other disease.
  </p>
  <h2 class="heading">
    Medical Bills are a Burden for Many Individuals and Families
  </h2>
  <p class="body">
    Expenses related to hospital stays, cancer treatments with high- cost chemotherapy routines, and other medicinal costs can be even higher. Treatment costs and necessary living expenses can bring the best of families to the brink of experiencing hard times. Insurance plans are not enough, as policies do not cover everything you need.
  </p>
  <h2 class="heading">
    Try Medical Crowdfunding
  </h2>
  <p class="body">
    Stop worrying about rising medical bills, or debts and start a medical fundraising campaign with Ketto. Ketto is a Crowdfunding Platform based out of India. Crowdfunding is the easiest way to avail support from friends, family and numerous individuals who are waiting to donate funds.  </p>
  <h2 class="heading">
    Start a Medical Fundraiser for Yourself or a Loved One
  </h2>
  <p class="body">
    With Ketto, you can start a free, easy fundraiser in minutes to cover medical bills and healthcare costs. You can also take on the role of spreading the word and bring in funds when a close friend is diagnosed with unexpected illnesses. Medical fundraising campaigns can give your well-wishers a way to express support when needed.  </p>
</div> -->

<div class="container-fluid">
  <div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 header" align="center">
          <h2 class="med-title">{{section.header}}</h2>
          <div class="hr"></div>
          <div class="desc">
            {{section.subheader}}
          </div>
        </div>
    </div>
    <div class="layout-div">
      <div class="row layout" [ngClass]="{'column-reverse': isMobile}">
        <div class="col-lg-6 col-md-12 textual-info">
          <h2 class="info-title">{{section.details[0].h2}}</h2>
          <div class="desc">
            {{section.details[0].desc}}
          </div>
        </div>
        <div class="col-lg-6 col-md-12 d-lg-block">
          <div class="img-div">
            <img loading="lazy" data-src="{{section.details[0]?.img_src}}" alt="How it works"/>
          </div>
        </div>
      </div>
      <div class="row layout">
        <div class="col-lg-6 col-md-12">
          <div class="img-div">
            <img loading="lazy" data-src="{{section.details[1]?.img_src}}" alt="How it works"/>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <h2 class="info-title">{{section.details[1].h2}}</h2>
          <div class="desc">
            {{section.details[1].desc}}
          </div>
        </div>
      </div>
      <div class="row layout" [ngClass]="{'column-reverse': isMobile}" *ngIf="section?.details[2]">
        <div class="col-lg-6 col-md-12">
          <h2 class="info-title">{{section.details[2].h2}}</h2>
          <div class="desc">
            {{section.details[2].desc}}
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="img-div">
            <img loading="lazy" data-src="{{section.details[2]?.img_src}}" alt="How it works"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
